
export default superclass => class extends superclass  {
    updatePatternRollStepNumber(resolution) {
        if (this.patternRollStepNumber === undefined) {
            return;
        }
        let numSteps = resolution.getNumberOfStepsAtBaseResolution();
        this.patternRollStepNumber -= this.patternRollStepNumber % numSteps;
    }
    
    initPatternBuffer(stepNumber) {
        if (this.pattern) {
            let length = this.pattern.stepBuckets.length;
            this.patternRollStepNumber = stepNumber % length;
        } else {
            this.patternRollStepNumber = stepNumber;
        }
    }
}
